import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useSiteStats() {
  const [total, setTotal] = useState<number | null>(null);

  useEffect(() => {
    // Only fetch on the real site, not in Lovable preview
    const host = window.location.hostname;
    if (host.includes('lovable.dev') || host.includes('id-preview--')) return;

    supabase.functions
      .invoke('get-stats')
      .then(({ data }) => {
        if (data?.total && typeof data.total === 'number') {
          setTotal(data.total);
        }
      })
      .catch(() => {});
  }, []);

  return { total };
}
